import { institutions } from '@/mocks/institutions';
import { PHOTO_WORKING } from '@/constants/brand';

const successStories = [
  {
    icon: 'ri-government-line',
    text: 'Der LWL – Landschaftsverband Westfalen-Lippe setzt das Konzept im Rahmen von Modellregionen im Übergang Schule–Beruf für Integrationsfachdienste ein.',
  },
  {
    icon: 'ri-community-line',
    text: 'Die LAG Soziale Dienste Schleswig-Holstein hat mich eingeladen, mein Konzept und die Möglichkeiten der praktischen Umsetzung fachlich vorzustellen.',
  },
  {
    icon: 'ri-building-2-line',
    text: 'Die LAG WfbM Sachsen-Anhalt hat das Konzept als Modellregion aufgenommen und stellt es ihren Mitgliedseinrichtungen zur praktischen Erprobung zur Verfügung.',
  },
];

export default function Practice() {
  return (
    <section id="praxis" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950">
              In der Praxis angekommen
            </h2>
          </div>
          <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
            Mein Konzept ist bereits überregional im Einsatz – von Modellregionen im
            Übergang Schule–Beruf bis hin zu Werkstätten und Bildungsträgern.
          </p>
        </div>

        <div className="mt-8 space-y-3">
          {successStories.map((story) => (
            <div
              key={story.text}
              className="flex items-start gap-4 rounded-lg bg-background-100 border border-background-200 p-5"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-900 shrink-0">
                <i className={story.icon}></i>
              </span>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                {story.text}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12">
          <div>
            <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950">
              Einrichtungen, die bereits meine Konzepte anbieten
            </h3>
          </div>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-8">
            {institutions.map((group) => (
              <div key={group.region}>
                <div className="flex items-center gap-2">
                  <h4 className="text-sm font-heading font-semibold text-foreground-950">
                    {group.region}
                  </h4>
                  {group.modelRegion && (
                    <span className="rounded-full bg-accent-500 text-foreground-950 text-[10px] font-bold px-2 py-0.5">
                      Modellregion
                    </span>
                  )}
                </div>
                <ul className="mt-3 space-y-1.5">
                  {group.names.map((name) => (
                    <li key={name} className="text-sm text-foreground-600">
                      {name}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 rounded-lg bg-primary-50 border border-primary-100 p-6 md:p-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 items-center">
            <div>
              <div className="flex items-center gap-3">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500 text-background-50 shrink-0">
                  <i className="ri-newspaper-line text-xl"></i>
                </span>
                <h4 className="text-lg font-heading font-semibold text-foreground-950">
                  Praxisbeispiele
                </h4>
              </div>
              <p className="mt-4 text-sm text-foreground-700 leading-relaxed">
                Bereits veröffentlichte Zeitungsartikel über ehemalige Schüler geben einen
                persönlichen Einblick in ihre Erfahrungen mit dem Kurs. Künftig sollen
                weitere Praxisbeispiele, Erfahrungsberichte, Interviews, Fotos und Videos
                ergänzt werden.
              </p>
              <div className="mt-5 flex flex-wrap gap-3">
                <a
                  href="https://www.caritas-gelsenkirchen.de/beitraege/mehr-als-die-reine-justiz--gelebte-berufliche-teil/1379756/"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 text-background-50 px-5 py-2.5 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
                >
                  Zum Zeitungsartikel
                  <i className="ri-external-link-line"></i>
                </a>
                <a
                  href="https://storage.googleapis.com/mailerlite-uploads-prod/1363302/FkXSRvrba4rIjvOlaNHJo3mhiE9JSjNvnpqgmSk8.pdf"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-secondary-500 text-background-50 px-5 py-2.5 text-sm font-semibold hover:bg-secondary-600 transition-colors cursor-pointer"
                >
                  Artikel als PDF
                  <i className="ri-file-pdf-2-line"></i>
                </a>
              </div>
            </div>
            <div className="rounded-lg overflow-hidden w-full h-56 md:h-72">
              <img
                src={PHOTO_WORKING}
                alt="Stephanie Wolf bei der Arbeit an neuen Kurskonzepten"
                title="Stephanie Wolf Kurskonzepte Praxisbeispiele"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}